<template>
    <div>
        <el-card class="box-card">
            <div class="upload">
                <div class="tips">电子发票</div>
                <TencentyunCosUploadImg :propsimageUrl="imageUrl" @change="changeTencentyunCosUploadImg"></TencentyunCosUploadImg>
            </div>
            <div class="btns">
                <el-button type="primary" @click="clicksave">保存</el-button>
                <el-button type="info" @click="backCustomerRenewalOrder">返回</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg
  },
  data () {
    return {
      imageUrl: '',
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.imageUrl = this.parentdata.params.makeinvoiceurl
    },
    changeTencentyunCosUploadImg (url) {
      this.imageUrl = url
    },
    backCustomerRenewalOrder () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditCustomerRenewalOrder()
    },
    apiEditCustomerRenewalOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.parentdata.params.id,
        makeinvoiceurl: this.imageUrl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditCustomerRenewalOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
    margin-right: 20px;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.upload{
    display: flex;
    padding-top: 15px;
    align-items: center;
}
.tips{
    color:#999;
    width: 70px;
}
.btns{
    padding-top: 15px;
    padding-left: 70px;
}
</style>
